import { useState, useEffect, useCallback } from 'react';
import { useRestaurant } from '../../context/RestaurantContext';

const useFetchConversations = (userType, conversationType) => {
    const [conversations, setConversations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { restaurantId, loading: restaurantLoading } = useRestaurant();

    const fetchConversations = useCallback(async () => {
        // Wait for restaurant context initialization, but don't block if restaurantId is missing.
        // Backend can still return conversations based on restaurantUserId from JWT/cookie.
        if (restaurantLoading) {
            return;
        }

        setLoading(true);
        setError(null); 

        try {
            // Build URL with restaurantId for empresas
            let url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/conversations?type=${conversationType}`;
            if (userType === 'empresas' && restaurantId) {
                url += `&restaurantId=${restaurantId}`;
            }
               
            const response = await fetch(url, {
                method: 'GET',
                credentials: 'include',
            });

            if (!response.ok) throw new Error('Failed to fetch');
            const data = await response.json();
            
            setConversations(data.data || []); 
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false); 
        }
    }, [conversationType, restaurantId, restaurantLoading, userType]);

    useEffect(() => {
        if (conversationType) {
            setConversations([]); 
            fetchConversations();
        }
    }, [fetchConversations, restaurantId]);

    const clearConversations = () => {
        setConversations([]);
    };

    return { conversations, loading, error, fetchConversations, clearConversations };
};

export default useFetchConversations;



